<template>
  <v-menu
    :close-on-content-click="false"
    :nudge-width="200"
    max-width="280"
    v-model="menu"
    bottom
    offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        small
        v-bind="attrs"
        v-on="on"
        class="mr-4">
        <v-img
          max-width="18px"
          :src="require(`@/assets/social/icons/telegram-icon.svg`)"
          alt="" aspect-ratio="1">
        </v-img>
      </v-btn>
    </template>
    <v-card
      outlined>
      <v-card-text>
        <div
          align="center"
          justify="center">
            <v-img
              max-width="180"
              :src="require(`@/assets/media/telegram/telegram-qr-code.jpeg`)"
              :lazy-src="require(`@/assets/media/telegram/telegram-qr-code.jpeg`)"
              alt="Jindo coin telegram QR code" aspect-ratio="1"
              class="rounded">
            </v-img>
            <div class="my-5 mx-10">
              <span>
                Scan a code with a phone camera or
              </span>
            </div>
            <v-btn
              rounded color="primary"
              class="black--text text-capitalize"
              @click="clickUrl('https://t.me/jindocoinchat')">
              Launch chat room
            </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  data: () => ({
    menu: false
  }),
  methods: {
    clickUrl (value) {
      window.open(value, '_blank')
    }
  }
}
</script>
